<template>
	<section class="page">
		<el-tabs v-model="activeName">
			<el-tab-pane label="当前广告" name="list">
				<div class="content-box" v-if="activeName=='list'">
					<div class="operator">
						<div class="operator-col">
							<el-button size="mini" type="primary" @click="handleCreate()" v-loading="loadings.create">新建</el-button>
						</div>
					</div>
					<curd-table
						ref="listTable"
						:data-model="editorDataModel"
						:fields="tableFields"
						@doedit="handleEdit($event)"
						:list-url="'setting/list_ad/list'"
					></curd-table>
				</div>
			</el-tab-pane>
			<el-tab-pane label="历史广告" name="his">
				<div class="content-box" v-if="activeName=='his'">
					<curd-table
						ref="listTable"
						:data-model="editorDataModel"
						:fields="tableFields"
						@doedit="handleEdit($event)"
						:list-url="'setting/list_ad/his'"
					></curd-table>
				</div>
			</el-tab-pane>
		</el-tabs>
		<editor
			:show.sync="editorVisible"
			:data-model-name="editorDataModel"
			:record-id="editorId"
			:fields="editorFields"
			@change="refreshTable('listTable')"
			:default-value="defaultValue"
		></editor>
	</section>
</template>

<script>
import Editor from "@/components/Editor.vue";
import CurdTable from "@/components/CurdTable.vue";
import CurdPage from "@/mixins/CurdPage.js";

export default {
	mixins: [CurdPage],
	data() {
		return {
			loadings: {
				main: false
			},
			activeName: "list",
			editorVisible: false,
			editorDataModel: "Ad",
			editorId: "",
			defaultValue: {
				end_at: Math.round(new Date().getTime() / 1000 + 86400)
			},
			tableFields: [
				{
					name: "name",
					isTrans: false,
					sortable: "custom"
				},
				{
					name: "pos",
					isTrans: true,
					sortable: "custom"
				},
				{
					name: "key",
					isTrans: true,
					sortable: "custom"
				},
				{
					name: "pic",
					isTrans: true,
					sortable: false
				},
				{
					name: "pic_mobile",
					isTrans: true,
					sortable: false
				},
				{
					name: "link",
					isTrans: true,
					sortable: false
				},
				{
					name: "begin_at",
					isTrans: true,
					sortable: false,
					params: {
						type: "ts"
					}
				},
				{
					name: "end_at",
					isTrans: true,
					sortable: false,
					params: {
						type: "ts"
					}
				},
				{
					name: "meta_age",
					isTrans: true,
					sortable: false
				},
				{
					name: "meta_gender",
					isTrans: true,
					sortable: false
				}
			],
			editorFields: [
				{
					name: "name",
					isTrans: false,
					rules: ["required"],
					width: "100%"
				},
				{
					name: "pos",
					isTrans: true,
					rules: ["required"],
					col: 6
				},
				{
					name: "key",
					col: 6
				},
				{
					name: "link",
					isTrans: true,
					rules: ["required"]
				},
				{
					name: "pic",
					isTrans: true,
					rules: ["required"],
					col: 6
				},
				{
					name: "pic_mobile",
					isTrans: true,
					sortable: false,
					col: 6
				},

				{
					name: "begin_at",
					isTrans: true,
					params: {
						type: "ts"
					},
					col: 6
				},
				{
					name: "end_at",
					isTrans: true,
					params: {
						type: "ts"
					},
					col: 6
				},
				{
					name: "meta_age",
					isTrans: true,
					sortable: false
				},
				{
					name: "meta_gender",
					isTrans: true,
					sortable: false
				}
			]
		};
	},
	computed: {},
	created() {},
	mounted() {},
	methods: {},
	watch: {},
	components: {
		Editor,
		CurdTable
	}
};
</script>
<style lang="scss" scoped>
</style>
